@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.deleteLicenseButton {
  margin-left: variables.$std-margin-md;
}
